import { render } from "./VizioTwo.vue?vue&type=template&id=3c98a1c8"
import script from "./VizioTwo.vue?vue&type=script&lang=js"
export * from "./VizioTwo.vue?vue&type=script&lang=js"

import "./VizioTwo.vue?vue&type=style&index=0&id=3c98a1c8&lang=css"
script.render = render

export default script